import { toast } from 'react-toastify';
import axios from 'axios';
import { FORM_ERROR } from 'final-form';
import _ from 'lodash';
import { API_URLS, USER_CONTEXT, SERVER_ERROR } from '../actionTypes';
import { userPropsAction } from './user-v0.action';
import setAuthToken from '../../utils/setAuthToken';

export const checkEmailExists =
  ({ email, recaptchaToken }) =>
  async (dispatch) => {
    dispatch(userPropsAction({ isActionLoading: true }));

    try {
      const response = await axios({
        ...API_URLS.auth.checkEmailExists,
        data: { email, recaptchaToken },
      });
      dispatch({
        type: USER_CONTEXT.EMAIL_EXISTS_SUCCESS,
        payload: { workspaceStep: 'information', ...response.data },
      });
      dispatch(
        userPropsAction({
          isActionLoading: false,
          isEmailExists: false,
          signupEmail: email,
        })
      );
    } catch (error) {
      dispatch(userPropsAction({ isActionLoading: false }));
      const { data } = await error.response;
      dispatch(
        userPropsAction({
          isEmailExists: true,
          isEmailExistsMsg: data.message || 'Unknown error',
        })
      );
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  };

/**
 *
 * @param {object} data
 */
export const accountWithGoogleAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.auth.googleSignup,
      data,
    });
    dispatch({
      type: USER_CONTEXT.EMAIL_SUCCESS,
      payload: response.data,
    });
    dispatch(userPropsAction({ isActionLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    if (!error.response) {
      toast.error(SERVER_ERROR);
      return;
    }
    const { data } = await error.response;
    if (data && data.errors) {
      toast.error(data.errors.token);
    } else {
      if (data && data.details === 'EMAIL_EXISTS')
        dispatch(userPropsAction({ isEmailExists: true }));
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
    }
  }
};

/**
 *
 * @param {object} data
 */
export const googleLoginAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.auth.googleLogin,
      data,
    });
    dispatch({
      type: USER_CONTEXT.GOOGLE_LOGIN_SUCCESS,
      payload: response.data,
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    if (!error.response) {
      toast.error(SERVER_ERROR);
      return;
    }
    const { data } = await error.response;
    if (data && data.errors) {
      toast.error(data.errors.token);
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
    }
  }
};

//====================================
//======= workspace actions ==========
//====================================

/**
 * @param {object} data
 */
export const createWorkspaceAction = (data) => async (dispatch) => {
  setAuthToken();

  try {
    const response = await axios({ ...API_URLS.workspace.information, data });

    dispatch({
      type: USER_CONTEXT.CREATE_WORKSPACE_SUCCESS,
      payload: { workspaceStep: 'invitation', ...response.data },
    });

    dispatch(userPropsAction({ isActionLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.CREATE_WORKSPACE_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      _.map(data.errors, (value) => toast.error(value));
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {object} data
 */
export const workspaceManagementAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.workspace.management, data });
    dispatch({
      type: USER_CONTEXT.MANAGE_WORKSPACE_SUCCESS,
      payload: { workspaceStep: 'invitation', ...response.data },
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.MANAGE_WORKSPACE_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      _.map(data.errors, (value) => toast.error(value));
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {object} data
 */
export const workspacePlanAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.workspace.plan, data });
    dispatch({
      type: USER_CONTEXT.MANAGE_WORKSPACE_SUCCESS,
      payload: { workspaceStep: 'complete', ...response.data },
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.MANAGE_WORKSPACE_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

export const getWorkspacesAction = () => async (dispatch) => {
  dispatch(userPropsAction({ wsListLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.workspace.list });
    dispatch({
      type: USER_CONTEXT.GET_WORKSPACES_SUCCESS,
      payload: { ...response.data },
    });
    dispatch(userPropsAction({ wsListLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ wsListLoading: false, loggedInUser: false }));
    dispatch({ type: USER_CONTEXT.GET_WORKSPACES_FAILURE });
    const { data } = await error.response;
    const message = data && data.message ? data.message : error.message;
    toast.error(message);
  }
};

export const getIPAddressAction = () => async (dispatch) => {
  dispatch(userPropsAction({ ipAddressLoading: true }));
  try {
    const response = await axios({ ...API_URLS.workspace.ipAddress });
    dispatch({
      type: USER_CONTEXT.IP_ADDRESS_SUCCESS,
      payload: { ...response.data },
    });
    dispatch(userPropsAction({ ipAddressLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ ipAddressLoading: false }));
    dispatch({ type: USER_CONTEXT.IP_ADDRESS_FAILURE });
    const { data } = (await error.response) || {};
    const message = data && data.message ? data.message : error.message;
    toast.error(message);
  }
};
